import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import SoftBox from 'components/SoftBox';
import { color } from 'framer-motion';
import { useNavigate } from 'react-router-dom';


const ActionMenu = ({ items }) => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <SoftBox>
      <IconButton
        id="action-button"
        aria-controls={open ? 'action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ color: 'blueviolet' }} />
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}

        MenuListProps={{
          'aria-labelledby': 'action-button',
        }}

      >
        {items.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleClose();
              item.onClick();
              if (item?.isNavigate) {
                navigate(item?.path)
              }
            }}
            sx={{
              color: '#000',
              '&:hover': {
                backgroundColor: '#f0f0f0',
                color: '#333', // dark gray on hover
              },
              '&:focus': {
                backgroundColor: '#f0f0f0',
                color: '#333', // dark gray on hover
              },
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </SoftBox>
  );
};

export default ActionMenu;
